// extracted by mini-css-extract-plugin
export default {"pixelNumber":"PixelNumber_pixelNumber__e9AHD","svgCharacter":"PixelNumber_svgCharacter__fBpx3"};